var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFillClose = function SvgFillClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f44336",
    d: "M15.8 8c0 3.2-2.1 6.2-5.1 7.3s-6.6.1-8.7-2.4C0 10.4-.3 6.8 1.3 4 3 1.3 6.2-.2 9.4.4c3.6.7 6.4 3.9 6.4 7.6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.6 3.6 8 7.3 4.4 3.6l-.8.8L7.3 8l-3.7 3.6.8.8L8 8.7l3.6 3.7.8-.8L8.7 8l3.7-3.6z"
  })));
};
export default SvgFillClose;